import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
import { DevelopmentRequest } from '../../class/development-request';

@Injectable()
export class DevelopmentRequestService extends WebService {

    public getDevReq (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('report_by'));//venue,company,verified_by,report_user,department,worked_by

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/development-requests?${params}`, options);
    }

    public newDevReq(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/development-requests`, JSON.stringify(body) , { headers: this.headers } );
    }

    public updateDevReq(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/development-requests/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deleteDevReq(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/development-requests/${id}`, { headers: this.headers } );
    }

    public infoDevReq(id: number): Observable<Response> {
        return this.http.get( `${this.apiUrl}/development-requests/${id}`,  { headers: this.headers } );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/development-request/development-request.service.ts